import React, { useState, useEffect, useContext, useRef } from 'react';
import { withRouter, useLocation, Link } from 'react-router-dom';
import { Nav, Navbar, Dropdown, DropdownButton, ButtonGroup, Form } from 'react-bootstrap';
import {
	Logout,
	IcoItaly,
	IcoUnitedKingdom,
	IcoSpain,
	IcoGearUpdated,
	HomeSolid,
	IcoAdministration,
	IcoManageCustomers,
	IcoProfile,
} from '@icons';
import { getLanguages } from '@lib/api';
// import { OpenRepLogo /* PoweredbyOE, */ } from 'loghi';
import { SonarLogoSmall } from 'loghi';
import { Fragment } from 'react';
//import logoCompliance from 'img/logo-compliance.jpg';
// import { LevelContext } from '@components/contexts/LevelContext';
import { OETrans } from './translation/OETrans';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { translate } from './translation/translation';
import { UserContext } from './contexts/UserProvider';
import { NotificationCenter } from './novu/NotificationCenter';
import { NovuNotificationProvider } from './contexts/NovuProvider';
import { WithPermission } from '@lib/helpers/WithPermission';

const Header = () => {
	// const {
	// 	/*setUserLanguage,*/
	// 	devMode,
	// 	setDevMode,
	// } = useContext(LevelContext);

	const devMode = localStorage.getItem('devMode') === 'true' ? true : false;
	const setDevMode = (mode) => {
		localStorage.setItem('devMode', mode);
	};
	const { isOe, userAccess } = useContext(UserContext);
	//const [userLanguage, setUserLanguage] = useState([]);
	const location = useLocation();
	const [languages, setLanguages] = useState(JSON.parse(localStorage.getItem('languages')) ?? []); // eslint-disable-line
	const [activeLang, setActiveLang] = useState(localStorage.getItem('userLanguage') ?? 'IT');
	const userEmail = localStorage.getItem('userEmail');
	const isLoginPage = location.pathname === '/' ? true : false;
	const isClientThanks = location.pathname.indexOf('thanks') === 1 ? true : false;
	const [apiError, setApiError] = useState(false);

	const userMenuRef = useRef(null);

	useEffect(() => {
		if (!userMenuRef.current) return;
		userMenuRef.current.querySelector('.dropdown-toggle').setAttribute('aria-label', translate('common.menu.user', 'Menu utente'));

		const mutationObserver = new MutationObserver(() => {
			const notificationTrigger = document.querySelector('.nv-popoverTrigger');
			if (!notificationTrigger || !!notificationTrigger.getAttribute('aria-label')) return;
			notificationTrigger.setAttribute('aria-label', translate('common.menu.notifications', 'Menu notifiche'));
		});

		mutationObserver.observe(document.body, {
			childList: true,
			subtree: true,
		});
		return () => {
			mutationObserver.disconnect();
		};
	}, []);

	useEffect(() => {
		getLanguages()
			.then((retrievedLanguages) => {
				setLanguages(retrievedLanguages.data);
			})
			.catch((error) => {
				setApiError(true);
				console.error('Errore nel caricamento delle lingue');
			});
	}, []);

	useEffect(() => {
		// if (setUserLanguage) {
		localStorage.setItem('userLanguage', activeLang);
		// setUserLanguage(activeLang);
		// }
	}, [activeLang /*, setUserLanguage*/]);

	const handleSetDevMode = () => {
		setDevMode(!devMode);
	};

	// eslint-disable-next-line
	const LanguageDropdown = () => {
		//const { i18n } = useTranslation()

		/* const handleChange = ({ value }) => {
             i18n.changeLanguage(value)
             localStorage.setItem('externalyticsLanguage', value)
             window.location.reload()
          } */

		let activeFlagIcon = '';

		const icoItaly = <IcoItaly style={{ width: '25px', height: '25px' }} />;
		const icoUnitedKingdom = <IcoUnitedKingdom style={{ width: '25px', height: '25px' }} />;
		const icoSpain = <IcoSpain style={{ width: '25px', height: '25px' }} />;

		switch (activeLang) {
			case 'IT':
				activeFlagIcon = icoItaly;
				break;
			case 'EN':
				activeFlagIcon = icoUnitedKingdom;
				break;
			case 'ES':
				activeFlagIcon = icoSpain;
				break;
			default:
				break;
		}

		/* const flagIcon = (languageCode) => {
           let flagIcon = '';
  
           switch (languageCode) {
              case 'IT':
                 flagIcon = icoItaly;
                 break;
              case 'EN':
                 flagIcon = icoUnitedKingdom;
                 break;
              case 'ES':
                 flagIcon = icoSpain;
                 break;
              default:
                 break;
           };
  
           return flagIcon;
        } */

		return (
			<>
				<Nav activeKey={activeLang} onSelect={(k) => setActiveLang(k)}>
					<DropdownButton
						as={ButtonGroup}
						className="header-nav-dropdown lang ms-3"
						align="end"
						variant="outline-header"
						title={activeFlagIcon}
					>
						{languages
							.sort((a, b) => b.code.localeCompare(a.code))
							.map((language) => (
								<Fragment key={language.code}>
									<Dropdown.Item eventKey={language.code} className="px-2">
										{/* {flagIcon(language.code)}  */}
										{language.code}
									</Dropdown.Item>
								</Fragment>
							))}
					</DropdownButton>
				</Nav>
			</>
		);
	};

	const isAdministration =
		location.pathname.startsWith('/administration') || location.pathname.startsWith('/clients') || location.pathname.startsWith('/profile');

	return (
		<>
			{apiError ? (
				<div>
					<OETrans code="common.error.backend" fallback={'Errore di connessione col backend'} />
				</div>
			) : (
				<>
					{isClientThanks ? (
						<></>
					) : (
						<>
							<header id="site-header">
								<Navbar
									expand="lg"
									variant="light"
									className="custom-nav me-0"
									style={{
										display: 'grid',
										// gridTemplateColumns: "1fr auto 1fr"
										// N.D.R. this changes the right column to 1fr if user is OE or External Admin, to have the menu aligned in center
										gridTemplateColumns: `1fr auto ${isOe || userAccess.isExternalAdmin || userAccess.isProjectManager ? '1fr' : 'auto'}`,
									}}
								>
									{/* <Navbar.Collapse className="col-4 pe-0 ps-2rem"> */}
									<div>
										<Link
											to={'/projects'}
											className={`${isLoginPage ? 'd-block d-lg-none' : ''}`}
											style={{ marginLeft: '2rem' }}
											aria-label="Logo OpenRep, vai all'area progetti"
										>
											<SonarLogoSmall
												// className="openrep-logo-header"
												aria-hidden="true"
												style={{
													fill: 'var(--np-text-primary-color)',
												}}
											/>
										</Link>
									</div>
									{/* </Navbar.Collapse> */}
									{/* per avere hamburger menu automaticamente su schermi mobile */}
									<Navbar.Toggle aria-controls="central-nav" className="me-4" />
									<Navbar.Collapse className="p-0 w-100 me-2">
										<Nav
											activeKey={
												location.pathname.startsWith('/project') &&
												// N.D.R. this avoids the version with the home icon to be active when a project is opened
												(isOe || userAccess.isExternalAdmin || userAccess.isProjectManager)
													? '/projects'
													: location.pathname
											}
											// activeKey={location.pathname}
											id="central-nav"
											className={`mx-auto ${isLoginPage ? 'd-block d-lg-none' : ''}`.trim()}
										>
											<Nav.Link as={Link} to="/projects" eventKey="/projects">
												{/* N.D.R. this changes icon and label if user is OE or External Admin */}
												{isOe || userAccess.isExternalAdmin || userAccess.isProjectManager ? (
													<OETrans code="common.header.projects" fallback={'Progetti'} />
												) : (
													<>
														<HomeSolid
															style={{
																marginRight: '0.625rem',
															}}
														/>
														Home
													</>
												)}
											</Nav.Link>
											{/* <Nav.Link href='/reports' eventKey='/reports'>Reportistica</Nav.Link> */}
											<WithPermission permission="view-section-tenders">
												<Nav.Link as={Link} to="/tenders" eventKey="/tenders">
													<OETrans code="common.header.procedures" fallback={'Procedure'} />
												</Nav.Link>
											</WithPermission>
											<WithPermission permission="view-section-setup">
												<Nav.Link as={Link} to="/setup?funds" eventKey="/setup">
													<OETrans code="common.header.instruments" fallback={'Strumenti'} />
												</Nav.Link>
											</WithPermission>

											{/* {userRole < 70 && (
                                    <Nav.Link href="/opportunity" eventKey="/opportunity">
                                    <OETrans
                                       code="common.header.opportunity"
                                       fallback={"Opportunità"}
                                    />
                                    </Nav.Link>
                                 )} */}
										</Nav>
									</Navbar.Collapse>

									<Navbar.Collapse className="pe-2rem">
										<Nav className="ms-auto" activeKey={location.pathname.split('/').slice(0, 2).join('/')}>
											<DropdownButton
												ref={userMenuRef}
												as={ButtonGroup}
												className={`header-nav-dropdown general ${isLoginPage ? 'd-block d-lg-none' : ''} ${isAdministration ? 'active' : ''}`}
												align="end"
												variant="outline-header"
												title={<IcoGearUpdated className="userico" />}
											>
												{userEmail ? (
													<>
														<Dropdown.Header className="text-end" style={{ padding: '0.7rem 0' }}>
															{userEmail}
														</Dropdown.Header>
														<Dropdown.Divider />
													</>
												) : null}
												{isOe || userAccess.isExternalAdmin ? (
													<>
														{userAccess.isSuperAdmin && (
															<>
																<Dropdown.ItemText>
																	<Form.Check // prettier-ignore
																		type="switch"
																		label={translate('common.devmode', 'Modalità sviluppatore')}
																		checked={!!devMode}
																		{...(devMode && { checked: true })}
																		onChange={() => handleSetDevMode()}
																	/>
																</Dropdown.ItemText>
																<Dropdown.Divider />
															</>
														)}
														{isOe ? (
															<>
																<Dropdown.Item as={Link} to="/administration?users" eventKey="/administration" className="text-end p-2">
																	<OETrans code="common.menu.administration" fallback={'Amministrazione'} />
																	&nbsp;
																	<IcoAdministration className="dropdown-icon" />
																</Dropdown.Item>
																<Dropdown.Item as={Link} to="/clients?groups" eventKey="/clients" className="text-end p-2">
																	<OETrans code="common.menu.clients" fallback={'Gestione utenti'} />
																	&nbsp;
																	<IcoManageCustomers className="dropdown-icon" />
																</Dropdown.Item>
															</>
														) : null}
													</>
												) : null}
												<Dropdown.Item as={Link} to="/profile" className="text-end p-2">
													<OETrans code="common.profile" fallback={'Profilo'} />
													&nbsp;
													<IcoProfile icon={faUser} className="dropdown-icon" />
												</Dropdown.Item>
												<Dropdown.Item as={Link} to="/logout" className="text-end p-2">
													<OETrans code="common.menu.logout" fallback={'Esci'} />
													&nbsp;
													<Logout className="dropdown-icon-small" />
												</Dropdown.Item>
											</DropdownButton>
											<NovuNotificationProvider>
												<NotificationCenter />
											</NovuNotificationProvider>
											{/* <LanguageDropdown /> */}
										</Nav>
									</Navbar.Collapse>
								</Navbar>
							</header>
						</>
					)}
				</>
			)}
		</>
	);
};

export default withRouter(Header);
